var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var Tags = function (props) {
    var children = props.children;
    return <Container>{children}</Container>;
};
var Container = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=index.jsx.map